// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"464":"df6ccf9f","533":"94b6516c","676":"09b50f94"}[chunkId] + ".chunk.css";
};